<template>
    <div class="fill-height of-y d-flex flex-column">
        <div class="flex-grow-0 pa-2 d-flex justify-space-between align-center">
            <div>
                <v-btn
                        :disabled="false"
                        @click="exportReportData"
                        color="primary"
                        small
                        :loading="exportingData"
                >
                    Export
                </v-btn>
            </div>
            <div style="width: 30%">
                <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="pa-0 ma-0"
                ></v-text-field>
            </div>
        </div>
        <div class="flex-grow-1 of-y">
            <v-data-table
                    :search="search"
                    dense
                    fixed-header
                    height="100%"
                    class="fill-height of-y"
                    hide-default-footer
                    :headers="headers"
                    :items="rows"
                    :options="{itemsPerPage: rows.length}"
            ></v-data-table>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import {format} from "date-fns";

export default {
    components: {},
    props: {
        data: Array,
        reportType: String,
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            exportingData: false,
            search: null,
            headers: [
                {text: "Farm", value: "farm"},
                {text: "Employee", value: "employee"},
                {text: "Emp Code", value: "empCode"},
                {text: "Roll Call", value: "rollCalled"},
                {text: "Clock In", value: "clockIn"},
                {text: "Last Action", value: "lastAction"},
                {text: "Bin Units", value: "binUnits"},
                {text: "Piecework", value: "piecework"},
                {text: "PW Units", value: "pWUnits"},
                {text: "Hours", value: "hours"},
            ],
        }
    },
    watch: {},
    methods: {
        exportReportData() {
            this.exportingData = true;
            this.$newReqDownloadFile(
                    'POST',
                    `reports/daily/export`,
                    {
                        start: this.selectedDate,
                        farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                    },
                    `Daily Summary ${format(this.selectedDate, 'yyyy-MM-dd')}.xlsx`
            )
                    .then(data => {
                        console.log(data)
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.exportingData = false
                    })
        }
    },
    computed: {
        ...mapGetters(["farms", "availableFarms", "availableFarmIDs"]),
        rows() {
            return this.data.map(row => {
                try {
                    return {
                        farmID: row.farm.id,
                        farm: row.farm.description,
                        employee: row.emp.fullName,
                        empCode: row.emp.empCode,
                        clockIn: row.clockInStr,
                        rollCalled: row.rollCalledStr,
                        lastAction: row.lastActionStr,
                        binUnits: row.binUnits,
                        piecework: row.pieceWorkStr,
                        pWUnits: row.pieceWorkUnits,
                        hours: row.hours,
                    }
                } catch (e) {
                    console.log(e, row)
                    return null
                }
            })
                    .filter((row) => !!row)
                    .filter((row) => row && this.selectedFarm ? row.farmID === this.selectedFarm : true)
                    .filter(row => row.farmID ? this.availableFarmIDs.includes(row.farmID) : true)
        }
    },
}
</script>

<style scoped>

</style>